import { FC } from 'react'
import { skipToken } from '@reduxjs/toolkit/query'
import { useGetStocksQuery } from '../../../../../../../../../../store/api/stocks-api'
import useMaterialWidthOptions from '../../../../../../../../../../helpers/render/use-material-width-options'
import calculateStockAmount from '../../../../../../../../../../helpers/entities/stock/calculate-stock-amount'
import AutoComplete from '../../../../../../../../../../components/custom-form-controls/auto-complete'

interface PositionWidthInputProps {
    materialTypeDocId?: string
    value?: string
    onChange?: (value: string) => void
    onBlur?: () => void
    disabled?: boolean
}

const PositionWidthInput: FC<PositionWidthInputProps> = ({
    materialTypeDocId,
    value,
    onChange,
    onBlur,
    disabled,
}) => {
    const { data: stocksData } = useGetStocksQuery(
        materialTypeDocId
            ? {
                  filters: {
                      material: { material_type: { documentId: { $eq: materialTypeDocId } } },
                  },
                  populate: '*',
                  pagination: { page: 1, pageSize: 1000 },
              }
            : skipToken
    )

    const materialOptions = useMaterialWidthOptions({
        items: stocksData?.data,
        getWidth: item => item.material.width,
        getDocumentId: item => item.material.documentId,
        getStock: item => calculateStockAmount(item),
    })

    return (
        <AutoComplete
            options={materialOptions}
            placeholder={'Ширина'}
            disabled={disabled || !materialTypeDocId}
            allowClear
            style={{ width: '100%' }}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            getOptionKey={opt => opt.key}
        />
    )
}

export default PositionWidthInput
